import styled from "styled-components";

export const TooltipStyled = styled.div`
    .__react_component_tooltip.tooltip {
        max-width: 320px;
        padding: 16px 25px;

        color: var(--color-white);
        font-size: 14px;
        font-family: var(--font-DINPro);
        line-height: 20px;
        text-align: center;

        background-color: var(--color-peach);
        box-shadow: 10px 10px 24px 0 rgba(0, 23, 75, 0.05);
        opacity: 1;

        &.place-top {
            margin-top: -2px;

            &:after {
                border-top-color: var(--color-peach);
                border-top-width: 6px;
                border-top-style: solid;
            }
        }
    }
`;

export const TooltipButton = styled.div`
    display: flex;
    align-items: center;
    margin-left: 10px;
    padding: 2px;

    cursor: pointer;
`;
